import { Heart16, HeartStroke16 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';

export interface IFavoriteButtonProps {
  checked: boolean;
  onButtonClick(): void;
}

export const FavoriteButton: React.FC<IFavoriteButtonProps> = ({ checked, onButtonClick }) => {
  return (
    <div className={style['item']} data-testid="FavoriteButton-Button" onClick={onButtonClick}>
      {checked ? <Heart16 color="error_100" /> : <HeartStroke16 />}
    </div>
  );
};
